import { render } from "./nosotros.vue?vue&type=template&id=6bfac2a0"
const script = {}

import "./nosotros.vue?vue&type=style&index=0&id=6bfac2a0&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__